import { render, staticRenderFns } from "./ConfirmRestore.vue?vue&type=template&id=b9267be8&scoped=true"
import script from "./ConfirmRestore.vue?vue&type=script&lang=js"
export * from "./ConfirmRestore.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRestore.vue?vue&type=style&index=0&id=b9267be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9267be8",
  null
  
)

export default component.exports